/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountNotes} from '../models/AccountNotes';
import type {Error} from '../models/Error';

export interface SaveAccountNotes$Request {
    accountId: number;
    accountNotes: AccountNotes;
}

export interface SaveAccountNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountNotesRequest = createAction<PayloadData<void, SaveAccountNotes$Request>>('SAVE_ACCOUNT_NOTES__SAVE_ACCOUNT_NOTES__REQUEST');
export const saveAccountNotesSuccess = createAction<PayloadData<void, SaveAccountNotes$Request>>('SAVE_ACCOUNT_NOTES__SAVE_ACCOUNT_NOTES__SUCCESS');
export const saveAccountNotesFailure = createAction<PayloadData<Error, SaveAccountNotes$Request, true>>('SAVE_ACCOUNT_NOTES__SAVE_ACCOUNT_NOTES__FAILURE');

export const saveAccountNotesActions = [
    saveAccountNotesRequest,
    saveAccountNotesSuccess,
    saveAccountNotesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {AccountNotes} meta.accountNotes
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountNotes = (meta: SaveAccountNotes$Request, config?: SaveAccountNotes$Config) => {
    return {
        CALL_API: {
            types: saveAccountNotesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/notes`,
            TRANSPORT_REQUEST_BODY: meta.accountNotes,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

